function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17 11.62L19.56 9.06L17 6.5",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9L18 9",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17C4.58 17 1 14 1 9C1 4 4.58 1 9 1",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit2);
export default __webpack_public_path__ + "static/media/exit2.84acd5bfa9b7865ee6d37d936cf72ba3.svg";
export { ForwardRef as ReactComponent };